var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PremiumLayout,[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"background"}),_c('div',{staticClass:"main"},[_c('router-view',{key:_vm.$route.path,staticClass:"child-view"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }